import React, { useState, useEffect } from 'react';
import { Card, Button, Alert, Typography, Space } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import OdooConfigModal from './OdooConfigModal';
import { getOdooConfig, saveOdooConfig } from '../../api/odoo-crm';

const { Title, Text } = Typography;

const OdooSetup = () => {
  const [configModal, setConfigModal] = useState(false);
  const [hasConfig, setHasConfig] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const authState = useSelector((state) => state.authState.value);

  useEffect(() => {
    checkExistingConfig();
  }, []);

  const checkExistingConfig = async () => {
    try {
      const authToken = localStorage.getItem('authToken');
      const response = await getOdooConfig(authToken);
      setHasConfig(!!response.data);
      if (response.data && typeof response.data.isActive !== 'undefined') {
        setIsActive(!!response.data.isActive);
      }
    } catch (error) {
      setHasConfig(false);
    } finally {
      setLoading(false);
    }
  };

  const setupInitialConfig = async () => {
    try {
      // Use the provided Odoo credentials
      const config = {
        databaseName: "global-frontiers",
        url: "https://www.odoo.com/my/databases",
        email: "info@globalfrontiers.io",
        password: "Bhagya@12345"
      };

      const authToken = localStorage.getItem('authToken');
      await saveOdooConfig(config, authToken);
      setHasConfig(true);
    } catch (error) {
      console.error('Failed to setup Odoo config:', error);
    }
  };

  async function toggleActive(next) {
    try {
      setIsActive(next);
      const authToken = localStorage.getItem('authToken');
      await saveOdooConfig({ isActive: next ? 1 : 0 }, authToken);
    } catch (e) {
      setIsActive(!next);
    }
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <SettingOutlined /> Odoo CRM Integration
            </Title>
            <Text type="secondary">
              Configure Odoo CRM to automatically sync contacts with your KPIs
            </Text>
          </div>

          {hasConfig ? (
            <Alert
              message={`Odoo CRM is ${isActive ? 'enabled' : 'disabled'}`}
              description="Manage configuration using the button below."
              type={isActive ? 'success' : 'warning'}
              showIcon
            />
          ) : (
            <Alert
              message="Odoo CRM not configured"
              description="Set up your Odoo CRM credentials to enable automatic contact synchronization."
              type="warning"
              showIcon
            />
          )}

          <Space>
            <Button 
              type="primary" 
              onClick={() => setConfigModal(true)}
            >
              {hasConfig ? 'Update Configuration' : 'Configure Odoo CRM'}
            </Button>
            {!hasConfig && (
              <Button 
                onClick={setupInitialConfig}
              >
                Quick Setup (Use Default Credentials)
              </Button>
            )}
          </Space>
        </Space>
      </Card>

      <OdooConfigModal
        visible={configModal}
        onClose={() => {
          setConfigModal(false);
          checkExistingConfig();
        }}
        token={localStorage.getItem('authToken')}
      />
    </div>
  );
};

export default OdooSetup;